/**
 * The site's own origin, for the two places that need an absolute URL.
 *
 * Build-time consumers (sitemap.xml, the per-route `<link rel="canonical">`)
 * resolve it from the environment in `scripts/sitemap.ts`. The browser bundle
 * needs it too — JSON-LD has to name the page it describes with a full URL —
 * and it cannot read `process.env` or `window.location`: a prerender pass runs
 * the app on `127.0.0.1`, so an origin taken from the browser would bake
 * localhost into the markup crawlers read. Both paths therefore start from the
 * constant below.
 */

/** Production origin. Overridable for staging via VITE_SITE_URL / SITE_URL. */
export const DEFAULT_SITE_URL = 'https://vectime.cloud';

/** Trailing slashes removed, so `${SITE_URL}${path}` is always clean. */
export function normalizeSiteUrl(raw: string | undefined): string {
  // An empty value counts as unset: `VITE_SITE_URL=` sits in .env.example and
  // arrives as '' rather than undefined.
  return (raw?.trim() || DEFAULT_SITE_URL).replace(/\/+$/, '');
}

/**
 * Origin baked into the client bundle at build time.
 *
 * `import.meta.env` is absent when this module is pulled into a plain Node
 * process — the Vite config loads `scripts/sitemap.ts`, which imports this
 * file — hence the optional access rather than a direct read.
 */
export const SITE_URL = normalizeSiteUrl(import.meta.env?.VITE_SITE_URL);
